// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__EGygh","brandColorHeader":"Header_brandColorHeader__ixNnK","backgroundColorHeader":"Header_backgroundColorHeader__tNvDP","portal":"Header_portal__aZSwj"};